import { useQuery } from "@tanstack/react-query";
import { getSuggestionById } from "Services/ai";
import { trackError } from "Utils/errorMonitoring";

export default function useInvoiceContactSuggestions(invoice = {}, options = {}) {
    const { contact_receiver_suggestion_id, contact_supplier_suggestion_id } = invoice;

    return useQuery({
        queryKey: ['contacts', 'invoiceContactSuggestions', contact_receiver_suggestion_id, contact_supplier_suggestion_id],
        queryFn: async () => {
            let receiver_suggestion = null;
            let supplier_suggestion = null;

            if (contact_receiver_suggestion_id) {
                const response = await getSuggestionById(contact_receiver_suggestion_id);
                if (response) {
                    receiver_suggestion = response;
                }
            }

            if (contact_supplier_suggestion_id) {
                const response = await getSuggestionById(contact_supplier_suggestion_id);
                if (response) {
                    supplier_suggestion = response;
                }
            }

            return {
                receiver_suggestion,
                supplier_suggestion,
            };
        },
        ...options,
        refetchOnWindowFocus: false,
        onError: (error) => {
            trackError(error);
        }
    });
}